import { useEffect, useState } from 'react';
import { Logo } from '@/components/ui/Logo';

interface AuthLoadingStateProps {
  message?: string;
}

const STATUSES = [
  'Loading your menus…',
  'Syncing inventory…',
  'Checking Sysco connection…',
  'Almost ready…',
];

export const AuthLoadingState = ({ message = 'Preparing your kitchen' }: AuthLoadingStateProps) => {
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStatusIndex((i) => (i + 1) % STATUSES.length);
    }, 2000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-midnight-green text-ivory overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(60% 50% at 80% 0%, hsl(var(--copper) / 0.18), transparent 60%), radial-gradient(60% 50% at 0% 100%, hsl(var(--deep-teal) / 0.5), transparent 60%)',
        }}
      />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 w-full max-w-md px-6 text-center">
        <div className="flex justify-center mb-12">
          <Logo variant="horizontal" size="md" className="brightness-0 invert" />
        </div>

        <span className="eyebrow text-copper/90 justify-center">One moment</span>
        <h2 className="font-display text-4xl text-ivory mt-5 text-balance">{message}.</h2>

        {/* Indeterminate progress bar */}
        <div className="mt-10 h-px w-full max-w-xs mx-auto bg-ivory/15 overflow-hidden">
          <div className="h-full w-full bg-copper animate-progress-indeterminate" />
        </div>

        {/* Rotating status line */}
        <p
          key={statusIndex}
          className="mt-6 font-inter text-sm text-ivory/65 animate-fade-in"
        >
          {STATUSES[statusIndex]}
        </p>
      </div>
    </div>
  );
};
